import React from 'react';
import PropTypes from 'prop-types';
import ReactHelmet from 'react-helmet';

const DynamicHeader = props => (
  <ReactHelmet {...props.helmetProps}>
    <title>{props.title}</title>
    {props.children}
  </ReactHelmet>
);

DynamicHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  helmetProps: PropTypes.shape({}),
  title: PropTypes.string,
};

DynamicHeader.defaultProps = {
  children: null,
  helmetProps: {},
  title: 'Breezeway',
};

export default DynamicHeader;
